import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export const Team = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ _jsx("svg", {
        ref: ref,
        ...props,
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 32 32",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M19.9 27H3.68a1.17 1.17 0 01-1-.48 1.15 1.15 0 01-.17-1.06 9.67 9.67 0 0118.47 0A1.18 1.18 0 0119.9 27zM5.5 24.64h12.58a7.27 7.27 0 00-12.58 0zm22.82 1h-4.83a1.18 1.18 0 110-2.35h2.93a5.66 5.66 0 00-4.57-2.49 6.85 6.85 0 00-1.83.26 1.18 1.18 0 11-.65-2.26 8.8 8.8 0 012.48-.36 8.07 8.07 0 017.59 5.66 1.18 1.18 0 01-.16 1.06 1.21 1.21 0 01-.96.5zm-16.78-8.59c-3.13 0-5.49-2.77-5.49-6.44A5.56 5.56 0 0111.54 5 5.57 5.57 0 0117 10.61c0 3.55-2.43 6.44-5.46 6.44zm0-9.69a3.19 3.19 0 00-3.12 3.25c0 2.33 1.34 4.08 3.12 4.08s3.13-1.86 3.13-4.08a3.19 3.19 0 00-3.13-3.25zm10.91 9c-2.58 0-4.68-2.42-4.68-5.4a4.68 4.68 0 119.35 0c0 3.1-2.01 5.42-4.67 5.42zm0-7.83A2.37 2.37 0 0020.14 11c0 1.65 1.06 3 2.31 3s2.3-1.29 2.3-3a2.37 2.37 0 00-2.3-2.45z"
        })
    }));
Team.displayName = "Team";
